import styled from 'react-emotion';

export const Container = styled('div')`
  display: flex;
  align-items: center;
`;

export const Image = styled('img')`
  margin-right: 10px;
`;

export const Name = styled('span')`
  color: var(--grey-2);
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/components/User/user.theme.js